import React from 'react'
import { Avatar, Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { TbCopy } from 'react-icons/tb'
import useWallet from '@plug-core/hooks/useWallet'
import { getChainIcon } from '@plug-core/utils/getChainIcon'
import { shortAddress } from '@plug-core/utils/shortAddress'
import Touchable from '@components/Touchable'
import useToast from '@hooks/useToast'
import { Chain } from '@plug-core/interfaces/common'

const Address = ({
  icon,
  title,
  address,
  l2,
}: {
  icon: string
  title: string
  address?: string
  l2?: boolean
}) => {
  const navigate = useNavigate()
  const { setToastMessage } = useToast()
  const { t } = useTranslation()

  const onCopy = () => {
    navigator.clipboard.writeText(address || '')
    setToastMessage(t('deposit.addressCopied'))
    navigate(-1)
  }

  return (
    <Box mx={2} my={0.75}>
      <Touchable onClick={onCopy}>
        <Stack
          direction="row"
          alignItems="center"
          p={2}
          bgcolor="background.paper"
          borderRadius={1}
          sx={{
            ':hover': {
              bgcolor: '#23242b',
            },
          }}
        >
          <img src={getChainIcon(icon)} width={28} height={28} />

          <Stack mx={2}>
            <Stack direction="row" spacing={1} mt={0.5}>
              <Typography fontWeight="bold">{t(`addresses.${title}`)}</Typography>
              {l2 && (
                <>
                  <img src={getChainIcon(Chain.ARB)} width={16} height={16} />
                  <img src={getChainIcon(Chain.BASE)} width={16} height={16} />
                </>
              )}
            </Stack>
            <Typography fontSize={13} fontFamily="monospace" color="text.secondary">
              {shortAddress(address || '', { rightSize: 10, leftSize: 10 })}
            </Typography>
          </Stack>

          <Box ml="auto">
            <Avatar sx={{ bgcolor: 'background.paper' }}>
              <TbCopy color="white" size={20} />
            </Avatar>
          </Box>
        </Stack>
      </Touchable>
    </Box>
  )
}

export default () => {
  const { wallet } = useWallet()

  return (
    <Stack>
      <Address icon="icp" title="icpAccount" address={wallet.accountId} />
      <Address icon="icp" title="icpPrincipal" address={wallet.principalId} />
      <Address icon="btc" title="btcAddress" address={wallet.btcAddress} />
      <Address icon="eth" title="ethAddress" address={wallet.ethAddress} l2={true} />
      <Address icon="sol" title="solAddress" address={wallet.solAddress} />
      <Address icon="odin" title="odinAddress" address={wallet.principalId} />
    </Stack>
  )
}
